import React, { useState, useEffect, useMemo } from "react";
import {
  useTable,
  useSortBy,
  useGlobalFilter,
  useFilters,
  usePagination,
} from "react-table";
import {
  Button,
  Badge,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  InputGroup,
  InputGroupAddon,
} from "reactstrap";
import Spinner from "./../../helper/Spinner";
import { COLUMNS } from "./columns";
import "./table.css";
import { GlobalFilter } from "./../../Shipment/GlobalFilter";
export default function PCA_Cockpit({ allWatchesList, isLoading }) {
  const columns = useMemo(() => COLUMNS, []);
  //const data = useMemo(() => MOCK_DATA, [])
  const data = useMemo(
    () => (allWatchesList ? allWatchesList : [{}]),
    [allWatchesList]
  );
  // const [data, setData] = useState([])
  //console.log(allWatchesList)
  //console.log(allWatchesList.length)
  //console.log('This is the data: ', data)
  //console.log(isLoading)
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    //rows,
    page,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    prepareRow,
    state,
    setGlobalFilter,
  } = useTable(
    {
      columns,
      data,
      initialState: {
        pageSize: 100,
        hiddenColumns: [],
      },
      autoResetSortBy: false,
      autoResetPage: true,
      autoResetFilters: false,
      autoResetGlobalFilter: false,
      autoResetSelectedRows: false,
      autoResetRowState: false,
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const { globalFilter, pageIndex, pageSize } = state;

  //modal
  const [modal, setModal] = useState(false);
  const [ImageSrc, setImageSrc] = useState();
  const [dataForModal, setDataForModal] = useState([]);
  const [imagURLs, setImagURLs] = useState([]);
  const [zoomIn, setZoomIn] = useState();

  const handleImgClikc = (data) => {
    console.log(data.photos);
    setModal(!modal);
    setImageSrc(data.photos[0]);
    if (data.photos.length > 0) {
      setImagURLs(data.photos ? data.photos : []);
    }
    setDataForModal(data);
  };
  return (
    <>
      {!isLoading && (
        <div className="shippingTable" style={{ overflowX: "auto" }}>
          <div className="shippingListHeader">
            <Badge>
              <h3>Watch Hunter</h3>
            </Badge>
            <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} />
            <select
              className="form-control"
              style={{ width: "unset" }}
              value={pageSize}
              onChange={(e) => setPageSize(Number(e.target.value))}
            >
              {[5, 10, 15, 20, 30, 50, 100, "All"].map((pageSize) => (
                <option
                  key={pageSize}
                  value={pageSize === "All" ? 20000 : pageSize}
                >
                  Display {pageSize}
                </option>
              ))}
            </select>
          </div>

          <table {...getTableProps()} style={{ width: "97.8%" }}>
            <thead>
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column, index) => (
                    <th key={index}>
                      <div
                        className="d-block border-0"
                        {...column.getHeaderProps(
                          column.getSortByToggleProps()
                        )}
                      >
                        {column.render("Header")}
                        <span
                          style={
                            column.Header === "Photo" || column.Header === "xxx"
                              ? { display: "none" }
                              : {}
                          }
                        >
                          {column.isSorted
                            ? column.isSortedDesc
                              ? " 🔽"
                              : " 🔼"
                            : " ▶️"}
                        </span>
                      </div>
                      <div
                        className="d-flex"
                        style={{
                          maxWidth: "150px",
                          overflow: "hidden",
                          margin: "auto",
                        }}
                      >
                        {column.canFilter ? column.render("Filter") : null}
                      </div>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {page.map((row) => {
                prepareRow(row);
                return (
                  <tr {...row.getRowProps()}>
                    {row.cells.map((cell) => {
                      // console.log(cell)
                      return (
                        <td {...cell.getCellProps()}>
                          {cell.column.Header === "Photo" ? (
                            <img
                              className="smlImgForPCA_Cockpit"
                              loading="lazy"
                              src={
                                cell.row.original.photos[0]
                                  ? cell.row.original.photos[0]
                                  : "#"
                              }
                              alt="Watch"
                              onClick={() => {
                                handleImgClikc(cell.row.original);
                              }}
                            />
                          ) : (
                            //:
                            //cell.row.original.originalBox && cell.column.Header === "Brand"  ? `${cell.row.original.brand} Inc. ${cell.row.original.originalBox ? 'W' : 'n' } Box`
                            cell.render("Cell")
                          )}
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
          <div
            className="pageOptions"
            style={{
              marginLeft: "auto",
              marginRight: "auto",
              display: "table",
            }}
          >
            <Button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
              {"<<"}
            </Button>
            <Button onClick={() => previousPage()} disabled={!canPreviousPage}>
              Vorherige Seite
            </Button>
            <span>
              Page{" "}
              <strong>
                {pageIndex + 1} of {pageOptions.length}
              </strong>{" "}
            </span>
            <Button onClick={() => nextPage()} disabled={!canNextPage}>
              Nächste Seite
            </Button>
            <Button
              onClick={() => gotoPage(pageCount - 1)}
              disabled={!canNextPage}
            >
              {">>"}
            </Button>
          </div>
        </div>
      )}
      {isLoading && <Spinner />}
      <Modal
        size="lg"
        centered={true}
        isOpen={modal}
        toggle={handleImgClikc}
        style={{ maxWidth: "1100px", marginLeft: "350px" }}
      >
        {console.log(dataForModal)}
        <ModalHeader toggle={handleImgClikc}>Uhr Info & Bild</ModalHeader>
        <ModalBody className="ModalBody d-flex justify-content-between">
          <div className="mr-5 w-100">
          <div className='rowDescContainer d-flex justify-content-between'>
            <div className='rowtitle'>Brand:</div>
            <div className='rowValue'>{dataForModal.brand}</div>
          </div>
          <div className='rowDescContainer d-flex justify-content-between'>
            <div className='rowtitle'>Model:</div>
            <div className='rowValue'>{dataForModal.model}</div>
          </div>
          <div className='rowDescContainer d-flex justify-content-between'>
            <div className='rowtitle'>Refrence:</div>
            <div className='rowValue'>{dataForModal.refno}</div>
          </div>
          <div className='rowDescContainer d-flex justify-content-between'>
            <div className='rowtitle'>Caliber:</div>
            <div className='rowValue'>{dataForModal.caliber}</div>
          </div>
          <div className='rowDescContainer d-flex justify-content-between'>
            <div className='rowtitle'>Movement:</div>
            <div className='rowValue'>{dataForModal.movement}</div>
          </div>
          <div className='rowDescContainer d-flex justify-content-between'>
            <div className='rowtitle'>Bracelet Material:</div>
            <div className='rowValue'>{dataForModal.braceletMaterial}</div>
          </div>
          <div className='rowDescContainer d-flex justify-content-between'>
            <div className='rowtitle'>Case Material:</div>
            <div className='rowValue'>{'will update'}</div>
          </div>
          <div className='rowDescContainer d-flex justify-content-between'>
            <div className='rowtitle'>Dial Color:</div>
            <div className='rowValue'>{dataForModal.dialColor}</div>
          </div>
          <div className='rowDescContainer d-flex justify-content-between'>
            <div className='rowtitle'>Box:</div>
            <div className='rowValue'>{dataForModal.originalBox ? 'YES' : 'NO'}</div>
          </div>
          <div className='rowDescContainer d-flex justify-content-between'>
            <div className='rowtitle'>Papers:</div>
            <div className='rowValue'>{dataForModal.originalCert ? 'YES' : 'NO'}</div>
          </div>
          <div className='rowDescContainer d-flex justify-content-between'>
            <div className='rowtitle'>Purchase Date:</div>
            <div className='rowValue'>{'will update'}</div>
          </div>
          </div>
          <img
            className="mainModalImg"
            src={ImageSrc}
            loading="lazy"
            alt="Watch"
            style={zoomIn ? { transform: "scale(1.5)" } : { width: "50%" }}
            onClick={() => {
              setZoomIn(!zoomIn);
            }}
          />
        </ModalBody>
        <ModalFooter className="justify-content-between">
          <div className="imgContainer">
            {imagURLs
              ? imagURLs.map((pic, index) => {
                  return (
                    <img
                      key={index}
                      src={pic}
                      loading="lazy"
                      onClick={() => {
                        setImageSrc(pic);
                      }}
                      alt="watch"
                    ></img>
                  );
                })
              : ""}
          </div>
          <Button color="secondary" onClick={handleImgClikc}>
            Schließen
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}
